/**
 * Action and mutation types for wordpress/settings module
 */
const types = {
  FETCH: 'fetch',
  UPDATE: 'update'
}

export default types



// WEBPACK FOOTER //
// ./src/store/modules/wordpress/settings/types.js